import { createSlice } from '@reduxjs/toolkit'
import service from '../../axios/service'
import { setActionsHistory, setIsHandReplayed, setResetHistoryState } from './trainerHistory'
import { setHeroActions } from './trainerSession'
import {
	setHeroActivePlayer,
	setIsReady,
	setSavedHandId,
	setVillainActivePlayer,
	setVillainNoActivePlayer,
} from './trainerSettings'
import { getActionsHash } from './utils/getActionsHash'
import { getHeroHandIndex, getPercentValuesMoreCurrent } from '../../Trainer/utils/helpers'
import { getActionStruct, getRangeStruct } from '../_actions/helpers'
import { getFLine, getPrLine, getRLine, getTLine } from './utils/getTrainerLines'
import { prepareCustomTraceObj } from './utils/preSaveHandData'
import { getEffStacks } from './utils/getPlayersStacks'
import { getEndPot } from './utils/getEndPot'

const table = {
	isHeroErrorLastStage: false,
	isCorrectContinue: false,
	heroEquityLowPercent: null,
	allowedEffStacks: null,
	heroCombosState: {
		combos: null,
		draws: null,
		abs: null,
		eq: null,
		actions: null,
		heroEquityLowPercent: null,
		strategyStructure: null,
		rangedEquity: null,
		eqPerc: null,
	},
	initialGameMode: '',
	initialStartQuery: '',
	initialEffStack: '',
	heroDrillActivePlayer: null,
	sessionId: null,
	isSuccessAction: false,
	isShowActionOnTable: false,
	currentHeroActionOnTable: null,
	data: null,
	isReady: false,
	abs: null,
	currentQuery: null,
	activePlayer: null,
	isLoadingData: false,
	isLoadingCreationSession: false,
	isShowDown: false,
	isShowHeroActions: false,
	stateStorage: [],
	lastHeroAction: {},
	isLastAction: false,
	isGameEnd: false,
	villainPercentage: 0,
	isRealReqLoading: false,
	isHeroActionLoading: false,
	isForbiddenUndo: false,
	endStatus: '',
	heroHandIndexFromStr: null,
	prLine: '',
	fLine: '',
	tLine: '',
	rLine: '',
	combosOrder: '',
	ante: 0,
	isVillainAllIn: false,
	isHeroAllIn: false,
	isFlopLoading: false,
	isTurnLoading: false,
	isRiverLoading: false,
	isBoardLoading: false,
	isHeroWin: false,
	showDownMessage: '',
	isError: false,
	statusMessage: null,
	isShowBoardModal: false,
	heroRange: null,
	villainRange: null,
	heroEquity: null,
	villainEquity: null,
	main_ev: null,
	heroProb: null,
	villainProb: null,
	handNote: '',
	currentVillainPlayer: null,
	isStrategyLoading: false,
	playersQueue: ['UTG', 'UTG1', 'MP', 'MP1', 'HIJ', 'CO', 'BTN', 'SB', 'BB'],
	combos: null,
	draws: null,
	pageStep: 'settings',
	playersRandom: false,
	pot: null,
	potAnte: null,
	currentAction: '',
	currentPlayer: '',
	isFlop: false,
	isTurn: false,
	isRiver: false,
	isTradeRound: '',
	evLoss: null,
	currentLine: '',
	trace: null,
	traceForSave: null,
	heroAction: '',
	playersAction: null,
	endAction: '',
	villainAction: '',
	isVillainActionLoading: false,
	flopReqQuery: null,
	turnReqQuery: null,
	riverReqQuery: null,
	flop: null,
	turn: null,
	river: null,
	startQuery: localStorage.getItem('startQuery') !== 'null' || 20,
	query: null, // here will be current query
	players: null,
	endActionQuery: null,
	handGPTAnalysis: null,
	isLoadingGPTAnalysis: false,
	isOpenGPTModal: false,
	table: null,
}

const preloadedData = {
	preloadedHandData: null,
	preloadedHero: null,
	preloadedActiveVillain: null,
	preloadedVillains: null,
	isLoadNextHand: false,
}

/**
 * Для работы 4 столов нужен массив столов и вспомогательных элементов.
 * Данные элементы находятся здесь и в других слайсах: trainerHistory, trainerSettings.
 * **/

const initialState = {
	tables: [table, table, table, table],
	sizings: [null, null, null, null],
	countOfTables: 1,
	trainerInfo: [[], [], [], []],
	preloadedHands: [preloadedData, preloadedData, preloadedData, preloadedData],
	startedConfigurationName: null,
}

const trainer = createSlice({
	initialState,
	name: 'trainer',
	reducers: {
		setHeroErrorLastStage(state, action) {
			const { index, data } = action.payload
			state.tables[index].isHeroErrorLastStage = data
		},
		/* setAnalysisGPT(state, action) {
			const { index, data } = action.payload
			state.tables[index].handGPTAnalysis = data
		},
		setIsLoadingGPTAnalysis(state, action) {
			const { index, data } = action.payload
			state.tables[index].isLoadingGPTAnalysis = data
		},
		setIsOpenGPTModal(state, action) {
			const { index, data } = action.payload
			state.tables[index].isOpenGPTModal = data
		}, */
		setPreloadedHandData(state, action) {
			const { data, index } = action.payload
			state.preloadedHands[index].preloadedHandData = data
		},
		setIsLoadNextHand(state, action) {
			const { index, data } = action.payload
			state.preloadedHands[index].isLoadNextHand = data
		},
		setPreloadedPlayers(state, action) {
			const { preloadedHero, preloadedActiveVillain, preloadedVillains, index } = action.payload

			state.preloadedHands[index].preloadedHero = preloadedHero
			state.preloadedHands[index].preloadedActiveVillain = preloadedActiveVillain
			state.preloadedHands[index].preloadedVillains = preloadedVillains
		},
		setIsBoardLoading(state, action) {
			const { index, data } = action.payload
			state.tables[index].isBoardLoading = data
		},
		setErrorDialogState(state, action) {
			const { index, data } = action.payload
			state.tables[index].isErrorDialogOpen = data
		},
		setLastActionError(state, action) {
			const { index, data } = action.payload
			state.tables[index].isLastActionError = data
		},
		setIsLoadingInitData(state, action) {
			const { index, data } = action.payload
			state.tables[index].isLoadingData = data
		},
		setLastHeroAction(state, action) {
			const { index, data } = action.payload
			state.tables[index].lastHeroAction = data
		},
		setEvLoss(state, action) {
			const { index, data } = action.payload
			state.tables[index].evLoss = data
		},
		setSessionId(state, action) {
			const { index, data } = action.payload
			state.tables[index].sessionId = data
		},
		setIsVillainAllIn(state, action) {
			const { index, data } = action.payload
			state.tables[index].isVillainAllIn = data
		},
		setEndActionQuery(state, action) {
			const { index, data } = action.payload
			state.tables[index].endActionQuery = data
		},
		setIsSuccessAction(state, action) {
			const { index, data } = action.payload
			state.tables[index].isSuccessAction = data
		},
		setHandNoteFromTrainer(state, action) {
			const { index, data } = action.payload
			state.tables[index].handNote = data
		},
		setIsHeroAllIn(state, action) {
			const { index, data } = action.payload
			state.tables[index].isHeroAllIn = data
		},
		setVillainNoActivePlayerIsFold(state, action) {
			const { index, data } = action.payload
			const { villainNoActivePlayer, isFold } = data

			if (state.tables[index].players?.[villainNoActivePlayer]) {
				state.tables[index].players[villainNoActivePlayer].isFold = isFold
			}
		},
		setPageStep(state, action) {
			const { index, data } = action.payload
			state.tables[index].pageStep = data
		},
		setShowBoardModal(state, action) {
			const { index, data } = action.payload
			state.tables[index].isShowBoardModal = data
		},
		setIsCorrectContinue(state, action) {
			const { index, data } = action.payload
			state.tables[index].isCorrectContinue = data
		},
		setIsGameEnd(state, action) {
			const { index, data } = action.payload
			state.tables[index].isGameEnd = data
		},
		setIsLastAction(state, action) {
			const { index, data } = action.payload
			state.tables[index].isLastAction = data
		},
		setPlayersActionObj(state, action) {
			const { index, data } = action.payload
			state.tables[index].playersAction = data
		},
		setPlayersFull(state, action) {
			const { index, data } = action.payload
			state.tables[index].players = data
		},
		setIsHeroWin(state, action) {
			const { index, data } = action.payload
			state.tables[index].isHeroWin = data
		},
		setIsForbiddenUndo(state, action) {
			const { index, data } = action.payload
			state.tables[index].isForbiddenUndo = data
		},
		setIsHeroActionLoading(state, action) {
			const { index, data } = action.payload
			state.tables[index].isHeroActionLoading = data
		},
		// CurrentLine
		setCurrentLine(state, action) {
			const { index, data } = action.payload
			state.tables[index].currentLine = data
		},
		setEndStatus(state, action) {
			const { index, data } = action.payload
			state.tables[index].endStatus = data
		},
		setVillainProgressValue(state, action) {
			const { index, data } = action.payload
			state.tables[index].villainPercentage = data
		},
		setCurrentAction(state, action) {
			const { index, data } = action.payload
			state.tables[index].currentAction = data
		},
		setIsRealReqLoading(state, action) {
			const { index, data } = action.payload
			state.tables[index].isRealReqLoading = data
		},
		setResetState(state, action) {
			const { index } = action.payload
			state.tables[index] = table
		},
		setPot(state, action) {
			const { index, data } = action.payload
			state.tables[index].pot = data
		},
		setPlayersRandom(state, action) {
			const { index, data } = action.payload
			state.tables[index].playersRandom = data
		},
		setShowHeroActions(state, action) {
			const { index, data } = action.payload
			state.tables[index].isShowHeroActions = data

			if (data === true) {
				state.tables[index].isForbiddenUndo = false
			}
		},
		setFlopValue(state, action) {
			const { index, data } = action.payload
			state.tables[index].flop = data
		},
		setStartedConfigurationName(state, action) {
			state.startedConfigurationName = action.payload
		},
		setTurnValue(state, action) {
			const { index, data } = action.payload
			state.tables[index].turn = data
		},
		setRiverValue(state, action) {
			const { index, data } = action.payload
			state.tables[index].river = data
		},
		setVillainActionLoading(state, action) {
			const { index, data } = action.payload
			state.tables[index].isVillainActionLoading = data
		},
		setIsTradeRound(state, action) {
			const { index, data } = action.payload
			state.tables[index].isTradeRound = data
		},
		setPlayersActionDone(state, action) {
			const { index, data } = action.payload
			const { playerAction, isActionDone, player } = data

			const prevStake = state.tables[index].playersAction[player].stake
			const playerInitBet = state.tables[index].players[player].initBet
			const { isFlop } = state.tables[index]

			const stake = playerAction.includes('Raise')
				? playerAction.split(' ')[2]
				: playerAction.includes('Bet')
				? playerAction.split(' ')[1]
				: playerAction.includes('Call')
				? playerAction.split(' ')[1]
				: prevStake || (!prevStake && !isFlop ? playerInitBet : null)
			if (player) {
				state.tables[index].playersAction[player].action = playerAction
				state.tables[index].playersAction[player].isActionDone = isActionDone
				state.tables[index].playersAction[player].stake =
					stake !== null ? +stake : prevStake || (!prevStake && !isFlop ? playerInitBet : null)
			}
		},
		setResetPlayersAction(state, action) {
			const { index } = action.payload
			for (const el in state.tables[index].playersAction) {
				// No clearing action if it was fold
				if (state.tables[index].playersAction[el].action !== 'Fold') {
					state.tables[index].playersAction[el].action = ''
					state.tables[index].playersAction[el].isActionDone = false
				}
			}
		},
		setResetPlayersActionStake(state, action) {
			const { index } = action.payload
			for (const el in state.tables[index].playersAction) {
				state.tables[index].playersAction[el].stake = null
			}
		},
		setShowDown(state, action) {
			const { index, data } = action.payload
			state.tables[index].isShowDown = data
		},
		setIsLoadingCreationSession(state, action) {
			const { index, data } = action.payload
			state.tables[index].isLoadingCreationSession = data
		},
		setIsFlop(state, action) {
			const { index, data } = action.payload
			state.tables[index].isFlop = data
		},
		setIsTurn(state, action) {
			const { index, data } = action.payload
			state.tables[index].isTurn = data
		},
		setIsRiver(state, action) {
			const { index, data } = action.payload
			state.tables[index].isRiver = data
		},
		setStartTrainerQuery(state, action) {
			const { index, data } = action.payload
			state.tables[index].startQuery = data
			localStorage.setItem('startQuery', data)
		},
		setHeroAction(state, action) {
			const { index, data } = action.payload
			state.tables[index].heroAction = data
		},
		setVillainAction(state, action) {
			const { index, data } = action.payload
			state.tables[index].illainAction = data
		},
		setCurrentQuery(state, action) {
			const { index, data } = action.payload
			state.tables[index].currentQuery = data
		},
		setEndAction(state, action) {
			const { index, data } = action.payload
			const { player, endAction } = data
			state.tables[index].endAction = { player, endAction }
		},
		setQuery(state, action) {
			const { index, data } = action.payload
			state.tables[index].query = data
		},
		setHeroDrillPlayer(state, action) {
			const { index, data } = action.payload
			const { player } = data
			state.tables[index].heroDrillActivePlayer = player
		},
		setBoardReqQueries(state, action) {
			const { index, data } = action.payload
			const { flopQuery, turnQuery, riverQuery } = data
			state.tables[index].flopReqQuery = flopQuery
			state.tables[index].turnReqQuery = turnQuery
			state.tables[index].riverReqQuery = riverQuery
		},
		setErrorMessage(state, action) {
			const { index, data } = action.payload
			state.tables[index].statusMessage = data
		},
		setIsError(state, action) {
			const { index, data } = action.payload
			state.tables[index].isError = data
		},
		setIsShowActionOnTable(state, action) {
			const { index, data } = action.payload
			state.tables[index].isShowActionOnTable = data
		},
		setCurrentHeroActionOnTable(state, action) {
			const { index, data } = action.payload
			state.tables[index].currentHeroActionOnTable = data
		},
		setAllowedEffStacks(state, action) {
			const { index, data } = action.payload
			state.tables[index].allowedEffStacks = data
		},
		setPotAnte(state, action) {
			const { pot, index } = action.payload
			state.tables[index].potAnte = pot
		},
		setData(state, action) {
			const { index, data } = action.payload

			if (state.tables[index].activePlayer !== null) {
				state.tables[index].players[state.tables[index].activePlayer].active = false
				state.tables[index].players[state.tables[index].activePlayer].actions = {}
			}

			const { info, matrixThreshold, heroActivePlayer } = data
			const {
				actions,
				player,
				currentQuery,
				abs,
				pot,
				trace,
				villain_abs,
				combos,
				draw,
				table,
				villain_player,
				villain_equity,
				equity,
				main_ev,
				prob,
				villain_prob,
				combosOrder,
			} = info

			// set heroHand index (abs, ev, eq)
			const str = getRangeStruct({ abs, eq: equity, ev: main_ev, combos, prob })
			state.tables[index].heroHandIndexFromStr = getHeroHandIndex(str, state.tables[index].players[player].handIndex)
			state.tables[index].pot = pot
			state.tables[index].potAnte = table.pot
			state.tables[index].trace = trace
			state.tables[index].activePlayer = player
			state.tables[index].currentQuery = currentQuery
			state.tables[index].heroRange = abs
			state.tables[index].villainRange = villain_abs
			state.tables[index].combosOrder = combosOrder
			state.tables[index].ante = table.ante * table.players?.length || 0
			state.tables[index].heroProb = prob
			state.tables[index].villainProb = villain_prob
			state.tables[index].heroEquity = equity
			state.tables[index].villainEquity = villain_equity
			state.tables[index].main_ev = main_ev
			state.tables[index].table = table

			if (heroActivePlayer && player === heroActivePlayer) {
				state.tables[index].heroCombosState.actions = actions
				state.tables[index].heroCombosState.abs = abs
				state.tables[index].heroCombosState.eq = equity
				state.tables[index].heroCombosState.combos = combos
				state.tables[index].heroCombosState.draws = draw
				state.tables[index].eqPerc = equity[state.tables[index].players[heroActivePlayer].handIndex]

				state.tables[index].heroCombosState.heroEquityLowPercent =
					state.tables[index].players[player] &&
					getPercentValuesMoreCurrent({
						struct: str,
						matrixThreshold,
						heroHand:
							state.tables[index].players[player].hand &&
							[state.tables[index].players[player].hand[1], state.tables[index].players[player].hand[0]].join(''),
					})['foundHandPercent']

				state.tables[index].heroCombosState.rangedEquity =
					state.tables[index].players[player] &&
					getPercentValuesMoreCurrent({
						struct: str,
						matrixThreshold,
						heroHand:
							state.tables[index].players[player].hand &&
							[state.tables[index].players[player].hand[1], state.tables[index].players[player].hand[0]].join(''),
					})['rangedPoints']

				state.tables[index].heroCombosState.strategyStructure = getActionStruct({
					actions: actions,
					combos: combos,
					draw: draw,
					abs: abs,
					equity: equity,
				})
			}

			state.tables[index].combos = combos
			state.tables[index].draws = draw
			state.tables[index].abs = abs
			state.tables[index].players[player].actions = actions
			state.tables[index].players[player].active = true
			state.tables[index].currentVillainPlayer = villain_player

			table.players.map((el) => (state.tables[index].players[el.name].isFold = el.is_fold))
			table.players.map((el) => (state.tables[index].players[el.name].stack = el.stack))
			table.players.map((el) => (state.tables[index].players[el.name].is_bet = el.is_bet))
			table.players.map((el) => (state.tables[index].players[el.name].range = el.range))
		},
		setResetTrainerInfo(state) {
			state.trainerInfo = initialState.trainerInfo
		},
		setHandNoteText(state, action) {
			const { index, data } = action.payload
			const { id, text } = data
			state.trainerInfo[index][id].handNoteText = text
		},
		setTrainerInfo(state, action) {
			const { index, data } = action.payload
			const { heroActivePlayer, actionsHistory, handId, isReplay = false } = data
			const infoObj = {
				pot: state.tables[index]?.pot,
				pos: heroActivePlayer && heroActivePlayer,
				hand:
					heroActivePlayer &&
					state.tables[index].players &&
					state.tables[index].players[heroActivePlayer] &&
					`${state.tables[index].players[heroActivePlayer].hand.join('')}`,
				stack: `${state.tables[index].currentQuery.split('_')[0]}`,
				evLoss: state.tables[index].evLoss,
				result: state.tables[index].endStatus,
				handId: handId || null,
				handNoteText: '',
				actionsHistory,
				date: new Date(),
				isReplayed: !!(handId || isReplay),
			}

			if (handId) {
				const indexHand = state.trainerInfo[index].findIndex((element) => element.handId === handId)
				state.trainerInfo[index][indexHand] = { ...state.trainerInfo[index][indexHand], ...infoObj }
			} else if (isReplay) {
				state.trainerInfo[index][0] = { ...state.trainerInfo[index][0], ...infoObj }
			} else {
				state.trainerInfo[index] = [infoObj, ...state.trainerInfo[index]]
			}
		},
		setTrainerInfoHandId(state, action) {
			const { index, data } = action.payload
			if (state.trainerInfo[index].length > 0) {
				state.trainerInfo[index][0].handId = data
			}
		},
		setHistoryState(state, action) {
			const { index, data } = action.payload
			Object.assign(state.tables[index], data)
			state.tables[index].isVillainActionLoading = false
		},
		setChangeObjInfoCond(state, action) {
			const { index, data } = action.payload
			const { actionsHistory, heroActivePlayer } = data

			// Remove extra fields
			const actionHistoryInfo = actionsHistory.map((obj) => {
				// actionsHash
				const { _, ...rest } = obj

				return rest
			})

			if (state.trainerInfo[index][0]) {
				state.trainerInfo[index][0].pos = heroActivePlayer
				state.trainerInfo[index][0].hand = state.tables[index]?.players?.[heroActivePlayer]?.hand?.join('')
				state.trainerInfo[index][0].evLoss = state.tables[index]?.evLoss
				state.trainerInfo[index][0].result = state.tables[index]?.endStatus
				state.trainerInfo[index][0].actionsHistory = actionHistoryInfo
				state.trainerInfo[index][0].date = new Date()
			}

			const prLine = getPrLine({ actionsHistory })
			const flopLine = getFLine({ actionsHistory })
			const turnLine = getTLine({ actionsHistory })
			const rLine = getRLine({ actionsHistory })

			state.tables[index].prLine = prLine
			state.tables[index].fLine = flopLine
			state.tables[index].tLine = turnLine
			state.tables[index].rLine = rLine
		},
		setPlayersHands(state, action) {
			const { index, data } = action.payload
			const { hand, handIndex, isDealer, initBet, player } = data

			state.tables[index].players[player].hand = hand
			state.tables[index].players[player].handIndex = handIndex
			state.tables[index].players[player].isDealer = isDealer
			state.tables[index].players[player].initBet = initBet
		},
		setPlayersSpecifications(state, action) {
			const { index, data } = action.payload
			const { isDealer, initBet, stack, player } = data

			state.tables[index].players[player].isDealer = isDealer
			state.tables[index].players[player].initBet = initBet
			state.tables[index].players[player].stack = stack
			state.tables[index].players[player].startBet = player === 'SB' ? 0.5 : player === 'BB' ? 1 : 0
		},
		setEndPlayerStack(state, action) {
			const { index, data } = action.payload
			const { endStack, player } = data
			state.tables[index].players[player].endStack = endStack
		},
		// For replaying current hand
		setReplayHand(state, action) {
			const { index, data } = action.payload
			const { startState } = data
			state.tables[index] = startState
		},
		setInitialGameMode(state, action) {
			const { index, data } = action.payload
			state.tables[index].initialGameMode = data
		},
		setInitialEffStack(state, action) {
			const { index, data } = action.payload
			state.tables[index].initialEffStack = data
		},
		setInitialStartQuery(state, action) {
			const { index, data } = action.payload
			state.tables[index].initialStartQuery = data
		},
		setUpdateTrainerInfo(state, action) {
			const { index, data } = action.payload
			state.trainerInfo[index] = { ...data, date: new Date() }
		},
		setResetHeroComboState(state, action) {
			const { index } = action.payload
			state.tables[index].heroCombosState = {
				combos: null,
				draws: null,
				abs: null,
				eq: null,
				actions: null,
				heroEquityLowPercent: null,
				strategyStructure: null,
			}
		},
		setTablesData(state, action) {
			const { index, data } = action.payload
			state.tables[index].tables.push(data)
		},
		setSizingsStructure(state, action) {
			const { index, data } = action.payload
			state.sizings[index] = data
		},
		setCountOfTable(state, action) {
			state.countOfTables = action.payload
		},
	},
})

export const setTrainerInfo =
	({ heroActivePlayer, actionsHistory, index, handId, isReplay }) =>
	(dispatch) => {
		dispatch(actions.setTrainerInfo({ data: { heroActivePlayer, actionsHistory, handId, isReplay }, index }))
	}

export const setIsShowActionOnTable = (value, index) => (dispatch) => {
	dispatch(actions.setIsShowActionOnTable({ data: value, index }))
}

export const setStartedConfigurationName = (name) => (dispatch) => {
	dispatch(actions.setStartedConfigurationName(name))
}

export const setHandNoteText = (id, text, index) => (dispatch, getState) => {
	const { trainerInfo } = getState().trainer

	if (id) {
		const indexCurrentRow = trainerInfo[index].findIndex((el) => el.handId === id)
		dispatch(actions.setHandNoteText({ data: { id: indexCurrentRow, text }, index }))
	} else {
		dispatch(actions.setHandNoteText({ data: { id: 0, text }, index }))
	}
}

export const setTrainerInfoHandId = (id, index) => (dispatch) => {
	dispatch(actions.setTrainerInfoHandId({ data: id, index }))
}

export const setHandNoteFromTrainer = (handNote, index) => (dispatch) => {
	dispatch(actions.setHandNoteFromTrainer({ data: handNote, index }))
}

export const setCurrentHeroActionOnTable = (value, index) => (dispatch) => {
	dispatch(actions.setCurrentHeroActionOnTable({ data: value, index }))
}

export const setIsSuccessAction = (value, index) => (dispatch) => {
	dispatch(actions.setIsSuccessAction({ data: value, index }))
}

export const setReplayHand = (index) => (dispatch, getState) => {
	dispatch(setIsHandReplayed(true, index))
	const startState = getState().trainerActionsHistory.tables[index].initialTrainerState

	const { trainerInfo } = getState().trainer

	const modifiedStartState = {
		...startState,
		trainerInfo: trainerInfo[index],
		isShowHeroActions: true,
	}
	dispatch(actions.setReplayHand({ data: { startState: modifiedStartState }, index }))
}

export const setChangeObjInfoCond =
	({ actionsHistory, heroActivePlayer, index }) =>
	(dispatch) => {
		dispatch(actions.setChangeObjInfoCond({ data: { actionsHistory, heroActivePlayer }, index }))
	}

export const setIsBoardLoading = (value, index) => (dispatch) => {
	dispatch(actions.setIsBoardLoading({ data: value, index }))
}

export const setPlayersActionObj = (val, index) => (dispatch) => {
	dispatch(actions.setPlayersActionObj({ data: val, index }))
}

export const setIsCorrectContinue = (value, index) => (dispatch) => {
	dispatch(actions.setIsCorrectContinue({ data: value, index }))
}

export const setIsHeroActionLoading = (value, index) => (dispatch) => {
	dispatch(actions.setIsHeroActionLoading({ data: value, index }))
}

export const setResetTrainerInfo = () => (dispatch) => {
	dispatch(actions.setResetTrainerInfo())
}

export const setIsHeroWin = (value, index) => (dispatch) => {
	dispatch(actions.setIsHeroWin({ data: value, index }))
}

export const setEvLoss = (value, index) => (dispatch) => {
	dispatch(actions.setEvLoss({ data: value, index }))
}

export const setShowBoardModal = (value, index) => (dispatch) => {
	dispatch(actions.setShowBoardModal({ data: value, index }))
}

export const setPageStep = (value, index) => (dispatch) => {
	dispatch(actions.setPageStep({ data: value, index }))
}

export const setHistoryState =
	({ historyState, index }) =>
	(dispatch) => {
		dispatch(actions.setHistoryState({ data: historyState, index }))
	}

export const setResetState = (flag, index) => (dispatch) => {
	dispatch(setResetHistoryState(index))
	!flag && dispatch(setIsReady(false))
	dispatch(actions.setResetState({ index }))
}

export const setCurrentAction = (currentAction, index) => (dispatch) => {
	dispatch(actions.setCurrentAction({ data: currentAction, index }))
}

export const setPlayersActionDone = (playersActionObj, index) => (dispatch) => {
	dispatch(actions.setPlayersActionDone({ data: playersActionObj, index }))
}
export const setShowHeroActions = (value, index) => (dispatch) => {
	dispatch(actions.setShowHeroActions({ data: value, index }))
}

export const setIsTradeRound = (value, index) => (dispatch) => {
	dispatch(actions.setIsTradeRound({ data: value, index }))
}

export const setVillainProgressValue = (value, index) => (dispatch) => {
	dispatch(actions.setVillainProgressValue({ data: value, index }))
}

export const setStartQuery = (startQuery, index) => (dispatch) => {
	dispatch(actions.setStartTrainerQuery({ data: startQuery, index }))
}

export const setResetPlayersAction = (index) => (dispatch, getState) => {
	const { heroActivePlayer } = getState().trainerSettings
	const { villainActivePlayer } = getState().trainerSettings
	dispatch(
		actions.setResetPlayersAction({
			data: {
				heroActivePlayer: heroActivePlayer[index],
				villainActivePlayer: villainActivePlayer[index],
			},
			index,
		})
	)
}

export const setShowDown = (value, index) => (dispatch) => {
	dispatch(actions.setShowDown({ data: value, index }))
}

export const setEndPlayerStack =
	({ endStacksArr, index }) =>
	(dispatch) => {
		for (const stack in endStacksArr) {
			dispatch(actions.setEndPlayerStack({ data: { endStack: endStacksArr[stack], player: stack }, index }))
		}
	}

// TODO: think about it
export const setResetStateForNewHand = (index) => (dispatch) => {
	dispatch(actions.setHeroErrorLastStage({ data: false, index }))
	dispatch(actions.setIsCorrectContinue({ data: false, index }))
	dispatch(actions.setIsFlop({ data: false, index }))
	dispatch(actions.setIsTurn({ data: false, index }))
	dispatch(actions.setIsRiver({ data: false, index }))
	dispatch(setEvLoss(null, index))
	dispatch(setIsHeroWin(false, index))
	dispatch(setShowDown(false, index))
	dispatch(setIsTradeRound('', index))
	dispatch(setSavedHandId(null))
	dispatch(setShowHeroActions(false, index))
	dispatch(setCurrentAction('action', index))
	dispatch(setActionsHistory('', 'over', index))
	dispatch(actions.setResetHeroComboState({ index }))
	dispatch(actions.setResetPlayersAction({ index }))
	dispatch(actions.setResetPlayersActionStake({ index }))
	dispatch(actions.setIsGameEnd({ data: false, index }))
	dispatch(setResetHistoryState(index))
	dispatch(actions.setResetPlayersActionStake({ index }))
	dispatch(actions.setIsLastAction({ data: false, index }))
	dispatch(actions.setEndStatus({ data: '', index }))
}

export const setDrillsPlayers =
	({ heroDrillsPlayer, allPlayers, index }) =>
	(dispatch, getState) => {
		dispatch(actions.setHeroDrillPlayer({ data: { player: heroDrillsPlayer }, index }))

		const { enablePositions } = getState().trainerSettings

		const villainNoActivePlayer = [
			...allPlayers.filter((el) => !enablePositions?.includes(el)),
			...enablePositions.filter((el) => !allPlayers?.includes(el)),
		]
		const villainActivePlayer = allPlayers?.filter(
			(el) => !villainNoActivePlayer?.includes(el) && el !== heroDrillsPlayer
		)

		dispatch(setHeroActivePlayer(heroDrillsPlayer, index))
		dispatch(setVillainActivePlayer(villainActivePlayer, index))
		dispatch(setVillainNoActivePlayer(villainNoActivePlayer, index))
	}

export const setInitTrainerSession =
	({ id, name, index }) =>
	async (dispatch) => {
		const url = `save_trainer_session`

		dispatch(actions.setIsLoadingCreationSession({ data: true, index }))
		try {
			const response = await service.post(url, { configuration_id: id })
			dispatch(actions.setSessionId({ data: response.data.session_id, index }))
			dispatch(setStartedConfigurationName(name))
			dispatch(actions.setIsLoadingCreationSession({ data: false, index }))
		} catch (e) {
			dispatch(actions.setIsLoadingCreationSession({ data: false, index }))
			console.log('error', e)
		}
	}

export const endActionDone =
	({
		query,
		playerAction,
		played,
		player,
		allActions,
		isActionErr,
		pickedActEv,
		isAllIn,
		actionEndStatus,
		rI,
		index,
	}) =>
	(dispatch, getState) => {
		const { heroActivePlayer } = getState().trainerSettings
		const villainActivePlayer = player !== heroActivePlayer[index] && player
		const { villainNoActivePlayer } = getState().trainerSettings
		const { currentQuery, combosOrder } = getState().trainer.tables[index]
		const currentPlayer = player === heroActivePlayer[index] ? 'hero' : 'villain'
		const { currentLine } = getState().trainer.tables[index]
		const realQuery = `${currentLine}_${query}`
		const { players = null, pot = null, isTradeRound = '' } = getState().trainer.tables[index]
		const effStack = getState().trainerSettings.effStack
		const gameMode = getState().trainerSettings.gameMode
		const currentTrainerState = { ...getState().trainer.tables[index] }

		// Count hero actions
		if (player === heroActivePlayer[index]) {
			const actionGroup =
				playerAction?.includes('Call') || playerAction?.includes('Check')
					? 'X/C'
					: (playerAction?.includes('Bet') || playerAction?.includes('Raise')) && !isAllIn
					? 'B/R'
					: playerAction?.includes('Fold') && 'F'
			dispatch(setHeroActions({ heroAction: playerAction, rI, actionGroup: isAllIn ? 'A' : actionGroup }))
		}

		/** To get end stack **/
		dispatch(actions.setEndActionQuery({ data: query || currentQuery, index }))

		const { actionsHistory } = getState().trainerActionsHistory.tables[index]
		const { ante, potAnte } = getState().trainer.tables[index]
		const startPot = actionsHistory?.[actionsHistory.length - 1]?.state?.pot || pot

		const endActionsHistory = [
			...actionsHistory,
			{
				role: player,
				type: 'action',
				action: playerAction,
				played,
				trace: currentTrainerState.trace.filter((el) => el.type !== 'stack'),
				query: query ? query.split('_').slice(0, -1).join('_') : currentQuery,
				isAllIn,
				isError: player === heroActivePlayer[index] && isActionErr === 'heroIsError',
				startPot,
			},
		]

		const endStack = getEffStacks({ players, startStack: Number(effStack), actionsHistory: endActionsHistory })

		// TODO: Add ante pot

		const endPot = endStack && getEndPot({ startStack: Number(effStack), endStack }) + ante

		/** Set last pot **/
		dispatch(actions.setPot({ data: endPot, index }))

		dispatch(setEndPlayerStack({ endStacksArr: endStack, index }))

		/** AFTER UPDATE STATE **/

		/** Prepared data for saving hand*/
		const customTraceObj = prepareCustomTraceObj({
			currentTrainerState,
			players,
			isBoard: false,
			player,
			actionType: 'action',
			query: query ? query.split('_').slice(0, -1).join('_') : currentQuery,
			playerAction,
			potAnte,
			pot: endPot,
			startPot,
			isTradeRound,
			combosOrder,
		})

		/** END **/

		player === villainActivePlayer &&
			villainNoActivePlayer &&
			villainNoActivePlayer[index].map((el) =>
				dispatch(
					actions.setVillainNoActivePlayerIsFold({
						data: {
							villainNoActivePlayer: el,
							isFold: true,
						},
						index,
					})
				)
			)

		dispatch(
			actions.setLastHeroAction({
				data: {
					actionName: playerAction,
					action: allActions,
				},
				index,
			})
		)
		const actionsHash = getActionsHash({ currentPlayer, player, allActions, players })
		dispatch(
			actions.setPlayersActionDone({
				data: {
					playerAction,
					isActionDone: true,
					player: player,
					isAllIn,
				},
				index,
			})
		)

		dispatch(
			setActionsHistory(
				{
					role: player,
					type: 'action',
					action: playerAction,
					played,
					trace: currentTrainerState.trace?.filter((el) => el.type !== 'stack'),
					actionsHash,
					query: query ? query.split('_').slice(0, -1).join('_') : currentQuery,
					isAllIn,
					isError: player === heroActivePlayer[index] && isActionErr === 'heroIsError',
					customTraceObj,
					isCorrect: isActionErr === 'heroNoError' && player === heroActivePlayer[index] && true,
					isHeroAction: player === heroActivePlayer[index],
					rI: player === heroActivePlayer[index] && rI,
				},
				'game',
				index
			)
		)
		dispatch(
			actions.setCurrentLine({
				data: realQuery,
				index,
			})
		)
		dispatch(actions.setIsGameEnd({ data: true, index }))

		// TODO: correct this code
		// ActionStatus
		if (
			(isActionErr === 'heroNoError' && playerAction.includes('Fold')) ||
			(isActionErr === 'heroNoError' && gameMode === 'action' && player === heroActivePlayer[index])
		) {
			const status = gameMode === 'action' ? 'Correct action' : `HFold`

			dispatch(actions.setEndStatus({ data: status, index }))

			/** no correct for action error **/
			dispatch(actions.setIsCorrectContinue({ data: true, index }))
		} else if (playerAction.includes('Fold') && isActionErr === 'villainFolded' && player === villainActivePlayer) {
			dispatch(actions.setEndStatus({ data: `VFold`, index }))
		}

		if (actionEndStatus === 'allin_showdown') {
			dispatch(actions.setEndStatus({ data: `Showdown`, index }))
		}
		if (actionEndStatus === 'showdown') {
			dispatch(actions.setEndStatus({ data: `Showdown`, index }))
		}
		if (actionEndStatus === 'no_solution') {
			dispatch(actions.setEndStatus({ data: `No Solution`, index }))
		}

		if (actionEndStatus === 'street-end') {
			dispatch(actions.setEndStatus({ data: `Street ended`, index }))
		}

		// Ev Loss
		if (isActionErr === 'heroIsError' && player === heroActivePlayer[index]) {
			dispatch(actions.setHeroErrorLastStage({ data: true, index }))
			const maxEv = allActions.reduce((prev, current) => {
				if (current.ev[players[player].handIndex] > prev.ev[players[player].handIndex]) {
					return current
				}

				return prev
			})
			const showDownEv = pickedActEv - maxEv.ev[players[player].handIndex]
			dispatch(actions.setEvLoss({ data: showDownEv.toFixed(2), index }))
			dispatch(actions.setIsLastAction({ data: true, index }))
			dispatch(actions.setEndStatus({ data: `Error`, index }))
		}
		if (isActionErr === 'villainFolded' || isActionErr === 'heroNoError') {
			dispatch(actions.setIsCorrectContinue({ data: true, index }))
		} else if (isActionErr === 'heroIsError' && player === heroActivePlayer[index]) {
			dispatch(actions.setShowDown({ data: true, index }))
		} else if (isActionErr === 'villainShowdown' && player === villainActivePlayer) {
			dispatch(actions.setIsCorrectContinue({ data: true, index }))
		}
	}

export const fetchNewTableData =
	(query, playerAction, actionType, played, player, state, allActions, isAllIn, rI, index) => (dispatch, getState) => {
		const nextMainPot = allActions.find((el) => el.action === playerAction).nextTable.main_pot
		const { spotId, heroActivePlayer } = getState().trainerSettings
		const currentPlayer = player === heroActivePlayer[index] ? 'hero' : 'villain'
		const { players, initialGameMode, isTradeRound, activePlayer, combosOrder } = getState().trainer.tables[index]
		const villainActivePlayer = player !== heroActivePlayer[index] && player
		const matrixThreshold = getState().preferences.dataNew.common.matrix.threshold

		//  Count hero actions
		if (player === heroActivePlayer[index]) {
			const actionGroup =
				playerAction.includes('Call') || playerAction?.includes('Check')
					? 'X/C'
					: playerAction?.includes('Bet') || playerAction?.includes('Raise')
					? 'B/R'
					: playerAction?.includes('Fold') && 'F'
			dispatch(setHeroActions({ heroAction: playerAction, rI, actionGroup: isAllIn ? 'A' : actionGroup }))
		}

		dispatch(actions.setIsForbiddenUndo({ data: true, index }))
		const actionsHash = getActionsHash({ currentPlayer, player, allActions, players })
		const currentTrainerState = { ...getState().trainer.tables[index] }

		const realQuery =
			query && actionType === 'action'
				? query.split('_').slice(0, -1).join('_')
				: query.split('_').slice(0, -2).join('_')

		/** AFTER UPDATE STATE **/
		const { actionsHistory } = getState().trainerActionsHistory.tables[index]
		const { potAnte = null, pot = null } = getState().trainer.tables[index]

		const startPot = actionsHistory?.[actionsHistory.length - 1]?.state?.pot ?? pot

		/** Prepared data for saving hand*/

		const customTraceObj = prepareCustomTraceObj({
			currentTrainerState,
			players,
			isBoard: false,
			player,
			actionType: 'action',
			query: realQuery,
			playerAction,
			potAnte,
			pot,
			startPot,
			isTradeRound,
			combosOrder,
		})

		/** END **/

		const historyObj = {
			role: player,
			type: 'action',
			action: playerAction,
			played,
			state: currentTrainerState,
			trace: currentTrainerState.trace?.filter((el) => el.type !== 'stack'),
			actionsHash,
			query: realQuery,
			isAllIn,
			customTraceObj,
			startPot,
			isCorrect: player === heroActivePlayer[index] && true,
			isHeroAction: player === heroActivePlayer[index],
			rI: player === heroActivePlayer[index] && rI,
		}

		// Check if hero or villain All-in
		if (player === villainActivePlayer && isAllIn) {
			dispatch(actions.setIsVillainAllIn({ data: isAllIn, index }))
		} else if (player === heroActivePlayer[index] && isAllIn) {
			dispatch(actions.setIsHeroAllIn({ data: isAllIn, index }))
		}

		const nextTablePot = allActions.find((item) => item.action === playerAction)?.nextTable?.pot ?? 0
		dispatch(actions.setPotAnte({ pot: nextTablePot, index }))

		if (initialGameMode === 'action' && activePlayer === heroActivePlayer[index]) {
			dispatch(
				endActionDone({
					query: actionType === 'action' ? query : query.split('_').slice(0, -1).join('_'),
					playerAction,
					played,
					player,
					allActions,
					isActionErr: 'heroNoError',
					pickedActEv: '',
					isAllIn,
					actionEndStatus: 'action',
					index,
				})
			)
		} else {
			const url = 'get_trainer_strategy'
			const payload = {
				id: spotId,
				q: query,
			}
			try {
				// Active player action request
				if ((player === villainActivePlayer || player === heroActivePlayer[index]) && actionType === 'action') {
					dispatch(actions.setCurrentAction({ data: 'action', index }))
					player === heroActivePlayer[index] &&
						dispatch(
							actions.setPlayersActionDone({
								data: {
									playerAction,
									isActionDone: true,
									player,
									isAllIn,
								},
								index,
							})
						)

					if (player === heroActivePlayer[index]) {
						dispatch(actions.setPot({ data: nextMainPot, index }))
						dispatch(setActionsHistory(historyObj, 'game', index))
					}

					// Timeout for player loading

					if (player === villainActivePlayer) {
						dispatch(actions.setVillainActionLoading({ data: true, index }))
						dispatch(actions.setIsRealReqLoading({ data: true, index }))
					}

					service
						.post(url, payload, {}, (result) => dispatch(setVillainProgressValue(result, index)))
						.then(({ data }) => {
							player === villainActivePlayer &&
								player === villainActivePlayer &&
								dispatch(actions.setVillainActionLoading({ data: false, index }))
							player === villainActivePlayer && dispatch(actions.setIsRealReqLoading({ data: false, index }))
							dispatch(
								actions.setPlayersActionDone({
									data: {
										playerAction,
										isActionDone: true,
										player,
										isAllIn,
									},
									index,
								})
							)
							player === villainActivePlayer && dispatch(setActionsHistory(historyObj, 'game', index))

							dispatch(
								actions.setData({
									data: {
										info: data,
										matrixThreshold,
										heroActivePlayer: heroActivePlayer[index],
									},
									index,
								})
							)
							dispatch(
								actions.setCurrentLine({
									data: query,
									index,
								})
							)
						})
						.catch((error) => {
							console.log('error', error)
						})
				}

				// board request
				if (player && (actionType === 'flop' || actionType === 'turn' || actionType === 'river')) {
					if (initialGameMode === 'street') {
						dispatch(
							endActionDone({
								query: query.split('_').slice(0, -1).join('_'),
								playerAction,
								played,
								player,
								allActions,
								isActionErr: 'heroNoError',
								pickedActEv: '',
								isAllIn,
								actionEndStatus: 'street-end',
								index,
							})
						)
					} else {
						if (player === heroActivePlayer[index]) {
							dispatch(
								actions.setPlayersActionDone({
									data: {
										playerAction,
										isActionDone: true,
										player,
										isAllIn,
									},
									index,
								})
							)
							dispatch(setActionsHistory(historyObj, 'game', index))
							dispatch(
								actions.setCurrentLine({
									data: query,
									index,
								})
							)
						}

						dispatch(actions.setIsBoardLoading({ data: true, index }))

						service
							.post(url, payload, {}, (result) => dispatch(setVillainProgressValue(result, index)))
							.then(({ data }) => {
								dispatch(
									actions.setData({
										data: { info: data, matrixThreshold, heroActivePlayer: heroActivePlayer[index] },
										index,
									})
								)
								dispatch(
									actions.setCurrentLine({
										data: query,
										index,
									})
								)
								dispatch(actions.setIsBoardLoading({ data: false, index }))
							})
							.catch((error) => {
								console.log('error', error)
							})

						if (player === villainActivePlayer) {
							dispatch(
								actions.setPlayersActionDone({
									data: {
										playerAction,
										isActionDone: true,
										player,
										isAllIn,
									},
									index,
								})
							)
						}

						setTimeout(() => {
							if (player === villainActivePlayer) {
								dispatch(actions.setPot({ data: nextMainPot, index }))
							}

							dispatch(
								actions.setResetPlayersAction({
									data: { heroActivePlayer: heroActivePlayer[index], villainActivePlayer },
									index,
								})
							)
							dispatch(actions.setResetPlayersActionStake({ index }))
							actionType === 'flop' && dispatch(actions.setIsFlop({ data: true, index }))
							actionType === 'turn' && dispatch(actions.setIsTurn({ data: true, index }))
							actionType === 'river' && dispatch(actions.setIsRiver({ data: true, index }))
							dispatch(actions.setCurrentAction({ data: actionType, index }))
							dispatch(
								actions.setCurrentLine({
									data: query,
									index,
								})
							)
							player === villainActivePlayer && dispatch(setActionsHistory(historyObj, 'game', index))
						}, 0)
					}
				}
			} catch (e) {
				console.log('error', e.error)
			}
		}
	}

export const setSizingsStructureData = (trainerSizings, index) => (dispatch) => {
	dispatch(actions.setSizingsStructure({ index, data: trainerSizings }))
}

export const setCountOfTable = (value) => (dispatch) => {
	dispatch(actions.setCountOfTable(value))
}

export const { reducer } = trainer
export const { actions } = trainer
